import styled from 'styled-components';
import BottomBg from '../../../../../Images/BottomBg.svg';

export const SectionCallToActionBGPattern = styled.div`
  background-image: url(${BottomBg});
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  bottom: 0;
  z-index: -1;
  opacity: 0.3;
`;

export const HeroWrapper = styled.div`
  padding-bottom: 50px;
`;

export const HeroLabel = styled.span`
  font-weight: bold;
  color: #fff;
  border-radius: 50px;
  padding: 0 2vw;
  position: relative;
  display: inline-block;
  z-index: 1;

  ::after {
    content: '';
    display: block;
    position: absolute;
    top: 5px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #4b4687;
    z-index: -1;
    border-radius: 50px;
  }
`;
export const HeroImage = styled.img`
  display: none;
  @media (min-width: 768px) {
    display: block;
  }
`;

export const BGImage = styled.img`
  position: absolute;
  z-index: -1;
  bottom: -10px;
  left: 0px;
  width: 100%;
`;
